<template>
  <div class="write-article-wapper">
    <a-row>
      <!--       <a-col
        :span="1"
        :style="{height:articleListHeight+'px'}"
        style="border-right: 5px solid #f1f1f1;"
      ></a-col>-->
      <a-col :span="6" :style="{height:articleListHeight+'px'}" style="overflow-y: scroll;">
        <div class="article-header">
          <a-button type="dashed" block style="margin:10px">
            <a-icon type="rollback"/>回文章
          </a-button>
          <a-button type="dashed" style="margin: 0 30px 0 0" @click="addArticle">
            <a-icon type="plus-circle"/>新建文章
          </a-button>
        </div>
        <div class="article-item-container">
          <div
            class="article-item"
            :class="{'item-selected':item.selcted}"
            v-for="(item,index) in articles"
            :key="index"
            @click="articleItemClick(item.id)"
          >
            <div class="article-item-title-container">
              <div class="article-item-title">{{item.title}}</div>
              <div v-show="item.selcted">
                <a-dropdown :trigger="['click']">
                  <a-icon type="setting" style="color:#fff;font-size:16px"/>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="publishArticle(item)">
                      <a-icon type="github"/>直接发布
                    </a-menu-item>
                    <a-menu-item key="2" v-show="item.state==300" @click="publishArticle(item)">
                      <a-icon type="github"/>取消发布
                    </a-menu-item>
                    <a-menu-item key="3" @click="delArticle(item,index)">
                      <a-icon type="apple"/>删除
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </div>
            <div class="article-item-date">{{item.createTime}}</div>
            <div class="article-item-content">{{item.outline}}</div>
          </div>
        </div>
      </a-col>
      <a-col :span="14" :offset="2">
        <a-spin :spinning="iSpinning">
          <div class="article-title">
            <div style="width: 80%;">
              <input type="text" class="title-content" v-model="articleTitle" placeholder="写下文章标题">
            </div>
            <div>
              <a-tag color="#87d068" style="color:">{{articleStatus}}</a-tag>
              <a-button
                :type="publishBtnType"
                style="font-size:14px"
                @click="publishArticle"
                :loading="isLoading"
              >{{publishBtnText}}</a-button>
            </div>
          </div>
          <my-quill-editor
            ref="quillEditor"
            :editHeight="editHeight"
            :content.sync="articleContent"
            @onEditorChange="editChange"
          ></my-quill-editor>
        </a-spin>
      </a-col>
    </a-row>
    <a-drawer
      title="Basic Drawer"
      placement="bottom"
      height="100%"
      :closable="true"
      :visible="isShowDrawer"
      @close="closeDrawer"
    >
      <p>Some contents...</p>
      <p>Some contents...</p>
      <p>Some contents...</p>
    </a-drawer>
  </div>
</template>

<script>
import myQuillEditor from '@/components/my-quill-editor'

import {
  // uploadImg,
  newArticle,
  getOwnArticleList,
  getArticle,
  deleteArticle,
  publishArticle
} from '@/apis/article'

export default {
  data () {
    return {
      articleListHeight: 0,
      articleStatus: '已保存',
      articles: [],
      articleTitle: '',
      articleContent: '',
      articleState: '',
      editHeight: {
        height: null
      },
      currentArticle: {
        title: '',
        content: null,
        id: null,
        html: '',
        text: ''
      },
      timeoutId: 0,
      isShowDrawer: false,
      isLoading: false,
      iSpinning: false,
      publishBtnType: 'primary'
    }
  },
  components: {
    myQuillEditor
  },
  computed: {
    publishBtnText: {
      get: function () {
        let text = ''
        switch (this.articleState) {
          case 100:
            text = '发布文章'
            break
          case 200:
            text = '审核中'
            break
          case 300:
            text = '已发布'
            break
          case 400:
            text = '发布更新'
            break
          default:
            break
        }
        return text
      },
      set: function () {}
    }
  },
  watch: {
    // 当 articleTitle变化时，列表标题同步变化
    articleTitle: function (newValue, oldValue) {
      for (let index = 0; index < this.articles.length; index++) {
        const element = this.articles[index]
        if (element.id === this.currentArticle.id) {
          element.title = this.articleTitle
          if (newValue !== this.currentArticle.title) {
            this.saveArticle()
          }
          break
        }
      }
    }
  },
  methods: {
    // 新建文章
    addArticle () {
      let article = {
        Id: 0,
        Title: '请写下文章标题',
        Content: '',
        Outline: ''
      }
      newArticle(article).then(res => {
        if (res.status === 200 && res.data.state === 1) {
          this.articles.unshift({
            id: res.data.attribute.id,
            title: article.Title,
            contents: '',
            createTime: res.data.attribute.createTime
              .substring(0, 10)
              .myReplace('-', '/')
          })
          this.articleItemClick(res.data.attribute.id)
        }
      })
    },

    // 点击文章列表
    articleItemClick (id) {
      if (this.currentArticle.id !== id) {
        let that = this
        this.iSpinning = true
        getArticle({ id }).then(res => {
          if (res.data.state === 1) {
            that.articleTitle = res.data.attribute.title
            that.articleContent = res.data.attribute.content
            that.articleState = res.data.attribute.state

            that.currentArticle = res.data.attribute
          }
          this.iSpinning = false
        })
        this.articles.map(
          item =>
            item.id === id ? (item.selcted = true) : (item.selcted = false)
        )
      }
    },

    // 当编辑器类容变化时,自动保存
    // 1、当前文章得状态为 100，也就是新建得文章没有发布过得，内容有变更时直接请求服务器
    // 2、当前文章得状态为 300，也就是已经发布过了，这是文章有变更时，要更改 ”发布文章“ 按钮的文字为 "发布更新"
    editChange (html, text) {
      this.currentArticle.html = html
      this.currentArticle.text = text
      if (this.articleContent !== this.currentArticle.html) {
        if (this.currentArticle.state === 300) {
          this.articleState = 400
        }
        this.saveArticle()
      }
    },

    // 保存文章
    saveArticle () {
      let that = this
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(function () {
        that.articleStatus = '保存中...'
        let outLine = ''
        if (that.currentArticle.text) {
          that.currentArticle.text < 1000
            ? (outLine = that.currentArticle.text)
            : (outLine = that.currentArticle.text.substring(0, 1000))
        }
        let article = {
          Id: that.currentArticle.id,
          Title: that.articleTitle,
          Content: that.currentArticle.html,
          Outline: outLine
        }
        newArticle(article).then(res => {
          if (res.status === 200 && res.data.state === 1) {
            that.articleStatus = '已保存'
          }
        })
      }, 1000)
    },

    // 发布文章
    // 无论当前文章的状态是100（发布文章），还是400（发布更新），发布成功后将当前文章的状态改为300（已发布）
    publishArticle (item) {
      let that = this
      if (this.articleState === 100 || this.articleState === 400) {
        this.isLoading = true
        publishArticle(this.currentArticle.id).then(res => {
          if (res.data.state === 1) {
            this.isLoading = false
            // this.isShowDrawer = true;
            this.articleState = 300
            this.$success({
              title: '文章发布成功啦',
              // JSX support
              content: '',
              okText: '前去列表查看',
              onOk () {
                that.$router.push('/articles')
              }
            })
          } else {
            this.isLoading = false
          }
        })
      } else {
        this.$message.warning('此文章已经发布过啦')
      }
    },

    // 删除文章
    delArticle (item, index) {
      let that = this
      this.$confirm({
        title: '你确定要删除此文章吗？',
        content: '请注意，删除后无法撤回！',
        okType: 'danger',
        maskClosable: true,
        onOk () {
          deleteArticle(item.id).then(res => {
            if (res.data.state === 1) {
              that.articles.splice(index, 1)
              if (that.articles.length && index > 0) {
                if (that.articles[index - 1]) {
                  that.articleItemClick(that.articles[index - 1].id)
                }
              } else {
                that.articleItemClick(that.articles[index].id)
              }
            }
          })
        }
      })
    },

    closeDrawer () {
      this.isShowDrawer = false
    }
  },

  mounted () {
    // eslint-disable-next-line
    String.prototype.myReplace = function(f, e) {
      var reg = new RegExp(f, 'g') // 创建正则RegExp对象
      return this.replace(reg, e)
    }

    this.iSpinning = true
    getOwnArticleList().then(res => {
      if (res.status === 200 && res.data.state === 1) {
        res.data.attribute.map((value, index) => {
          if (index === 0) {
            value.selcted = true
            getArticle({ id: value.id }).then(res1 => {
              if (res1.data.state === 1) {
                this.articleTitle = res1.data.attribute.title
                this.articleContent = res1.data.attribute.content
                this.articleState = value.state

                this.currentArticle = res1.data.attribute
                this.iSpinning = false
              }
            })
          } else {
            value.selcted = false
          }
          value.createTime = value.createTime
            .substring(0, 10)
            .myReplace('-', '/')
          this.articles.push(value)
        })
      }
    })

    this.articleListHeight = window.innerHeight
    this.editHeight = {
      height: `${window.innerHeight - 104}px`
    }
    window.onresize = () => {
      this.articleListHeight = window.innerHeight
      this.editHeight = {
        height: `${window.innerHeight - 104}px`
      }
    }
  }
}
</script>

<style lang="less" scoped>
.write-article-wapper {
  .article-header {
    position: fixed;
    width: inherit;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    z-index: 1;
    overflow-y: scroll;
    background-color: #fff;
  }

  .article-item-container {
    top: 60px;
    position: relative;

    .article-item {
      height: 140px;
      cursor: pointer;
      background-color: #f9f9f9;
      border-top: 1px solid #e8e8e8;
      padding: 18px 10px 2px 20px;

      .article-item-title-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .article-item-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 16px;
        }
      }

      .article-item-content {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        padding-top: 10px;
        line-height: 2;
      }

      .article-item-date {
        text-align: right;
      }
    }

    .article-item:hover {
      //border-left: 5px solid #ec7259;
      background-color: #87d068;
      color: #ffffff;
    }

    .item-selected {
      background-color: #87d068;
      color: #ffffff;
    }
  }

  .article-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    font-size: 30px;
    font-weight: 400;
    line-height: 30px;

    .title-content {
      width: 100%;
      margin-bottom: 0;
      border: none;
      font-size: 30px;
      font-weight: 400;
      line-height: 30px;
      -webkit-box-shadow: none;
      box-shadow: none;
      color: #2dbe60;
      background-color: transparent;
      outline: none;
      border-radius: 0;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    input::-webkit-input-placeholder {
      /* placeholder颜色  */
      color: #2dbe60;
    }
  }
}
</style>
